import styled from '@emotion/styled'

import { SimpleModal, SimpleTabStrip, Space, Typography } from '../..'
import Icon from '../../atoms/Icon'
import IconButton from '../../molecules/iconButton'
import { StepTab } from '../../molecules/step-tab/step-tab'
import { StyledSuccessText } from './trade-submitted-modal.styles'

export type TradeSubmittedModalProps = {
  acceptCaption: string
  description?: string
  onAccept: () => void
  open: boolean
  steps: string[]
}

const numberAsStr = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight']

const StyledTabs = styled.div`
  border-bottom: solid 1px var(--White90);
`

const TradeSubmittedModal = ({
  acceptCaption,
  description,
  onAccept,
  open,
  steps
}: TradeSubmittedModalProps) => {
  const getCount = () => {
    const stepsLength = steps.length
    if (stepsLength <= numberAsStr.length) {
      return numberAsStr[stepsLength]
    }
    return stepsLength.toString()
  }

  const renderTab = (tabName: string, tabPosition: number, isSelected: boolean) => (
    <StepTab
      isSelected={isSelected}
      state={isSelected ? 'complete' : 'pending'}
      stepNumber={tabPosition}
    >
      {tabName}
    </StepTab>
  )

  return (
    open && (
      <SimpleModal width="800px">
        <Space isflex flexDirection="column" justifyContent="center" p={6}>
          <Space isflex justifyContent="center" pb={6}>
            <Icon color="var(--Success)" name="circleCheck" size="xxxlarge" />
          </Space>
          <StyledSuccessText isflex justifyContent="center" pb={4}>
            <Typography fontSize="15px" fontWeight="800" letterSpacing={0} variant="sh3">
              Trade submitted!
            </Typography>
          </StyledSuccessText>
          {description && (
            <Space isflex justifyContent="center">
              <Typography variant="b3">{description}</Typography>
            </Space>
          )}
          {!description && (
            <>
              <Space isflex justifyContent="center" pb={6}>
                <Typography variant="b3">
                  {`The trade will now follow a ${getCount()} step activation process:`}
                </Typography>
              </Space>
              <Space isflex justifyContent="center">
                <StyledTabs>
                  <SimpleTabStrip>
                    {steps.map((step, index) => renderTab(step, index + 1, index === 0))}
                  </SimpleTabStrip>
                </StyledTabs>
              </Space>
            </>
          )}
          <Space isflex justifyContent="center" pt={6}>
            <IconButton
              disabled={false}
              icon={<Icon name="chevronLeft" size="small" />}
              iconPosition="left"
              operationType="progress"
              text={acceptCaption}
              onClick={() => onAccept()}
            />
          </Space>
        </Space>
      </SimpleModal>
    )
  )
}

export default TradeSubmittedModal
